// LOCAL STORAGE KEYS
// user
export const LOCAL_STORAGE_USER_INFO = "LOCAL_STORAGE_USER_INFO";
export const LOCAL_STORAGE_SESSION_EXPIRED = "LOCAL_STORAGE_SESSION_EXPIRED";